/**
 * Microsoft Authentication Library (MSAL) config for Azure AD auth
 * Following Azure best practices for browser-based auth to Azure Functions
 */

// Tenant ID from env or hardcoded (in real app, use env vars)
const tenantId = "98cbb543-5ebe-4c6f-ad51-e5e724b8ec6b";

// Get full origin for redirect
const baseUrl = window.location.origin;

export const msalConfig = {
  auth: {
    clientId: "82300107-9836-4f71-8562-47eff726f9fe", // SWA app ID
    authority: `https://login.microsoftonline.com/${tenantId}/v2.0`,
    redirectUri: `${baseUrl}/`,
    postLogoutRedirectUri: baseUrl,
    navigateToLoginRequestUrl: true,
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: true,
  },
  system: {
    // Avoid long UI stalls when browsers block 3rd-party cookies for iframe-based silent auth.
    iframeHashTimeout: 2000,
  },
};

// Use the correct Function App scope
export const loginRequest = {
  scopes: [
    "openid", 
    "profile", 
    "email", 
    "api://4726f043-2a2e-461b-b209-a19d2b527ed5/user_impersonation"
  ],
};
